import React from "react"
import PropTypes from "prop-types"
import { P } from "../../typography"
import { Container } from "./styles"

const Banner = ({ variant, text }) => (
  <Container variant={variant}>
    <P marginless align="center" size="small" bold>
      {text}
    </P>
  </Container>
)

Banner.propTypes = {
  variant: PropTypes.oneOf(["default", "danger", "warning", "success"]).isRequired,
  text: PropTypes.string.isRequired
}

Banner.defaultProps = {
  variant: "default",
  text: ""
}

export default Banner
